
import { Component, Prop, Vue } from "vue-property-decorator";
import DateHelper from "@/util/DateHelper";
import RideitInvitation, { RideitInvitationStatus } from '@/models/Rideit/RideitInvitation';
import SmsMessage, { SmsStatus } from '@/models/SmsMessage';
import { getInvitationStatus, RideitInvitationWithSmsStatus } from '@/util/rideitHelper';

export interface IInvitationWithSms {
  invitation: RideitInvitation;
  smsMessage: SmsMessage;
}

@Component({
  components: {},
})
export default class RideitInvitationCard extends Vue {
  @Prop({ required: true }) private item: IInvitationWithSms
  @Prop({ required: true}) private passengerName: string;

  dateHelper = new DateHelper();
  invitationStatus = RideitInvitationStatus;

  get acceptedByName() {
    if (this.item.invitation.acceptedByName) {
      return this.item.invitation.acceptedByName;
    }
    return '-';
  }

  get status() {
    return getInvitationStatus(this.item.invitation, this.item.smsMessage);
  }

  get statusText() {

    if (this.status === RideitInvitationWithSmsStatus.Failed) {
      return this.$t('sms.status.Failed');
    }
    if (this.status === RideitInvitationWithSmsStatus.Accepted) {
      return this.$t('rideIt.invitation_status.Accepted').toString();
    }
    if (this.status === RideitInvitationWithSmsStatus.Revoked) {
      return this.$t('rideIt.invitation_status.Revoked');
    }

    if (this.status === RideitInvitationWithSmsStatus.Expired) {
      return this.$t('rideIt.invitation_status.Expired');
    }

    if (this.status === RideitInvitationWithSmsStatus.Pending) {
      return this.$t('rideIt.invitation_status.Pending');
    }

    return this.$t(`sms.status.${SmsStatus[this.item.smsMessage.status]}`);
  }

  get sentText() {
    if (this.status === RideitInvitationWithSmsStatus.Failed) {
      return this.$t('rideIt.invitation_card.smsFailedAt');
    }
    return this.$t('rideIt.invitation_card.smsSentAt');
  }

  get sentTime() {
    if (this.status === RideitInvitationWithSmsStatus.Failed) {
      return this.dateHelper.formatDateTime(this.item.smsMessage.statusUpdatedAt);
    }
    return this.dateHelper.formatDateTime(this.item.smsMessage.sentAt);
  }


}
